<template>
  <div>
    <div class="desktop">
      <div class="reload">
        Обновите страницу
      </div>
    </div>
    <div class="contact">
      <router-link to="/fulfillment">
        <img
          class="logo-text"
          src="../assets/greysislogotext.svg"
          alt="Greysis Logo Text"
        />
      </router-link>
      <menu-icon></menu-icon>

      <div class="main-div">
        <div class="text">
          <div class="text-ins">
            <h1 class="info contact-title">
              Свяжитесь с <br />
              нами:
            </h1>
          </div>
          <div class="head"></div>
        </div>
        <div class="comp">
          <contact-comp></contact-comp>
        </div>
      </div>
      <div class="footer">
        <footerComp></footerComp>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import menuIcon from "../components/menuMobile.vue";
import contactComp from "../components/contact-comp.vue";
import footerComp from "../components/footer.vue";

export default {
  name: "contact",
  components: {
    menuIcon,
    contactComp,
    footerComp,
  },
  mounted() {
    $(".menu-icon").show();
    $(".sub-menu ul li").click(function() {
      $(".footer").css("position", "relative");
    });
    // Mouse over
    $(".active").mouseover(function() {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(2)");
    });
    $(".active").mouseleave(function() {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(1)");
    });
    // Progress
    var circle = document.getElementById("circle");
    var radius = circle.r.baseVal.value;
    var circumference = radius * 2 * Math.PI;

    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = `${circumference}`;

    function setProgress(percent) {
      const offset = circumference - (percent / 100) * circumference;
      circle.style.strokeDashoffset = offset;
    }

    setProgress(0);

    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }

    var supportsPassive = false;
    try {
      window.addEventListener(
        "test",
        null,
        Object.defineProperty({}, "passive", {
          get: function() {
            supportsPassive = true;
            return supportsPassive;
          },
        })
      );
    } catch (e) {
      console.log("");
    }

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent =
      "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";
    function enableScroll() {
      window.removeEventListener("DOMMouseScroll", preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
      window.removeEventListener("touchmove", preventDefault, wheelOpt);
      window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
    }

    enableScroll();
  },
};
</script>

<style scoped>
.desktop {
  display: block;
}

.contact {
  display: none;
}
.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

@media only screen and (max-width: 900px) {

  .info {
    font-size: 1.7em;
  }

  .contact-comp {
    vertical-align: top;
  }
  
  .head
  {
    position: absolute;
    width: 60%;
    height: 100%;
    background-image: url("../assets/head.png");
    background-size: contain;
    background-repeat: no-repeat;
    bottom: 0;
    right: 0;
    background-position: center;
  }

  .text-ins {
    width: 80%;
    margin: 0 auto;
    position: absolute;
    bottom: 0;
    left: 10vw;
  }

  .text {
    width: 100%;
    height: 200px;
    display: inline-block;
    position: relative;
  }

  .main-div {
    margin-top: 50px;
  }

  .comp {
    display: inline-block;
    vertical-align: top;
    margin-top: 30px;
    transform: scale(0.85) translateX(-10%);
    margin-left: 10vw;
  }

  .logo-text {
    width: 30vw;
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .nav {
    position: absolute;
    left: 20vw;
    top: 30px;
    width: 74vw;
  }

  .nav li {
    font-size: calc(0.6vw + 0.5vh + 0.5vmin);
    display: inline-block;
    padding: 0 15px;
    color: #dedede;
    opacity: 0.5;
    cursor: pointer;
    transition: 0.3s;
  }

  .nav li:hover {
    color: white;
    opacity: 1;
  }

  .contacts {
    float: right;
    text-transform: capitalize;
    font-family: Montserrat-SemiBold;
    color: white;
  }

  .contact
  {
    display: block;
  }

  .desktop
  {
    display: none;
  }

  *
  {
    overflow-x: hidden;
  }
}
</style>
